module.exports = __webpack_public_path__ + "img/机关党建-迅捷压缩.7f238d4a.png";